// removed by extract-text-webpack-plugin
module.exports = {"noScroll":"_9cR-VqKFeKU7uhNk2LFKP","zIndex":"_2i2gLvDUQSMzsTBQLlQ8ow","container":"_3vtwrUbE-yHHA_zEyLoyq6","centerContent":"_2v_iIUC-SrimIHBrIvcUiU","topContent":"_29c_vaPH2UhdvuJJqf7B8K","dialog":"nxG1dGGzJprAzDNvR9ix_","fullScreen":"w54s5Hk3Clun19XbriHJa","closeIcon":"oB-_tvBfO7r_w6RFLa91M","logo":"_2zc35pTAqVai6nrXT8wLrU","anim-open":"_1KxE_3p4t0EygYTzeQbf-k"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.scss
// module id = 452
// module chunks = 1